export class StatoApplicazioneVO {
  manutenzione: boolean;
  messaggio: string;
  dataInizioManutenzione: Date;
  nascondiFascicolazione: boolean;
  nascondiSoggettiEsterni: boolean;
  minKbPerAttivazioneFileDiGrandiDimensioni: number;
  minKbPerAttivazioneFileDiGrandiDimensioniSingoloDestinatario: number;
  nascondiVociPhylum: boolean;
}
